import { AspectRatio } from '@livecontrol/core-ui';
import { Time } from '@livecontrol/core-utils';
import { DateTime } from 'luxon';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-internal-modules
import * as States from '../../../../event-details/components/spotlight/player/states';
// eslint-disable-next-line import/no-internal-modules
import { Video } from '../../../../event-details/components/spotlight/player/video'; // to fix plugin error on build
import type { UntitledEvent } from '../../../graphql';
import { FallbackBackground } from '../fallback-background';
// import * as States from './states';

// import { Video } from './video';

const StyledDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 20px;

  > .full {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &.z-3 {
      z-index: 3;
    }
  }

  &,
  > .full,
  > .background {
    border-radius: 8px;
    overflow: hidden;
  }

  .x-light-theme & {
    color: var(--dark);
  }
  .x-dark-theme & {
    color: var(--white);
  }
  video[poster] {
    object-fit: fill;
  }

  .x-viewport-md &,
  .x-viewport-lg &,
  .x-viewport-xl & {
    border-radius: 8px;
  }
`;

export const Player = ({
  untitledEvent
}: {
  untitledEvent: UntitledEvent;
}): React.ReactElement => {
  const { scheduled_time } = untitledEvent;
  const isLive = untitledEvent.is_live;

  /**
   * Current player status should be shown only when video is played.
   * Otherwise, the player status along with play button will be shown.
   */
  const [playRequested, setPlayRequested] = useState(false);

  const onPlay = useCallback(() => {
    setPlayRequested(true);
  }, []);

  return (
    <AspectRatio ratio={3 / 2}>
      <StyledDiv>
        <FallbackBackground
          className='background'
          backgroundImage={
            untitledEvent.thumbnail_url ??
            '/assets/fallback-background.jpeg'
          }
        />

        {playRequested &&
          (!isLive && scheduled_time &&
          Time.now().timestamp >
            DateTime.fromISO(scheduled_time).plus({ minutes: 15 }) ? (
            <States.Complete className='full' />
          ) : (
            scheduled_time && <States.Countdown className='full' scheduledTime={DateTime.fromISO(scheduled_time)} />
          ))}

        <Video
          streamUrl={untitledEvent.stream_url}
          isLive={isLive}
          className='full z-3'
          onInitialPlay={onPlay}
          onPlay={onPlay}
        />
      </StyledDiv>
    </AspectRatio>
  );
};
